import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import $ from "jquery";
// import DataTable from "datatables.net";
import { Link, useLocation } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { useHistory } from "react-router";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import alertify from "alertifyjs";
import { date_format, datetime_format } from "../Common/DateFormat";

import { API_URL } from "../constants.js";
import {
  sampleIdFromSearch,
  normalizeReportEditSearchUrl,
  reportEditUrl,
} from "../Common/patientIdentifier";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";

const getTestDetailId = (detail) =>
  detail?.test_detail_id ?? detail?.test_detail?.id ?? detail?.id;

const formatResultForDisplay = (result) => {
  if (result == null || result === "" || result === 0 || result === "0") {
    return "";
  }
  return String(result);
};

const mergeTestDetailsFromSource = (targetPatient, sourcePatient) => {
  if (!sourcePatient?.patient_tests?.length) {
    return targetPatient;
  }
  const detailsByTestId = {};
  sourcePatient.patient_tests.forEach((pt) => {
    if (pt.test?.id && pt.test?.details?.length) {
      detailsByTestId[pt.test.id] = pt.test.details;
    }
  });
  return {
    ...targetPatient,
    patient_tests: targetPatient.patient_tests.map((pt) => ({
      ...pt,
      test: {
        ...pt.test,
        details:
          pt.test?.details?.length > 0
            ? pt.test.details
            : detailsByTestId[pt.test?.id] || [],
      },
    })),
  };
};

const normalizePatientTestsForEdit = (patient) => {
  const patient_tests = (patient.patient_tests || []).map((patientTest) => {
    const testDetails = patientTest.test?.details || [];
    const savedDetails = patientTest.patient_test_details || [];

    if (!testDetails.length) {
      return patientTest;
    }

    const savedByTestDetailId = {};
    savedDetails.forEach((saved) => {
      const key = getTestDetailId(saved);
      if (key != null) {
        savedByTestDetailId[key] = saved;
      }
    });

    const patient_test_details = testDetails.map((templateDetail) => {
      const testDetailId = templateDetail.id;
      const saved = savedByTestDetailId[testDetailId];

      if (saved) {
        return {
          ...saved,
          name: saved.name || templateDetail.name,
          result: formatResultForDisplay(saved.result),
          test_detail: saved.test_detail || templateDetail,
        };
      }

      return {
        patient_test_id: patientTest.id,
        test_detail_id: testDetailId,
        name: templateDetail.name,
        unit_id: templateDetail.unit_id ?? templateDetail.unit?.id,
        result: "",
        test_detail: templateDetail,
        flag: undefined,
        remarks: undefined,
      };
    });

    return { ...patientTest, patient_test_details };
  });

  return { ...patient, patient_tests };
};

const isAbnormalResult = (detail) => {
  const status = detail.flag || detail.remarks;
  return status === "lower" || status === "higher" || status === "negative";
};

const buildUpdateReportPayload = (patient) => ({
  patient: {
    id: patient.id,
    patient_tests: (patient.patient_tests || []).map((pt) => ({
      id: pt.id,
      patient_id: patient.id,
      test_id: pt.test_id ?? pt.test?.id,
      report_remarks_id: pt.report_remarks_id || 0,
      patient_test_details: (pt.patient_test_details || []).map((detail) => ({
        id: detail.id,
        test_detail_id:
          detail.test_detail_id ?? detail.test_detail?.id ?? getTestDetailId(detail),
        name: detail.name,
        unit_id:
          detail.unit_id ??
          detail.test_detail?.unit_id ??
          detail.test_detail?.unit?.id,
        result: detail.result ?? "",
        flag: detail.flag,
        remarks: detail.remarks,
      })),
    })),
  },
});

export function ReportEdit(props) {
  const sampleIdInput = useRef();
  const location = useLocation();
  const [age, setAge] = useState(0);
  const [message, setMessage] = useState("");

  const [disabled, setDisabled] = useState(0);
  const [iconDisabled, setIconDisabled] = useState(1);
  const [collectionCenters, setCollectionCenters] = useState([]);
  const [patient, setPatient] = useState({
    patient_tests: [],
  });
  const [show, setShow] = useState(false);
  const [statusModalShow, setStatusModalShow] = useState(false);
  const [selectedPatientStatus, setSelectedPatientStatus] = useState("0");
  const [remarks, setRemarks] = useState([]);

  const history = useHistory();

  const handleClose = () => {
    setStatusModalShow(false);
    setShow(false);
  };

  const applyPatientData = (patientData) => {
    setPatient(normalizePatientTestsForEdit(patientData));

    const today = new Date();
    const birthDate = new Date(patientData.dob);
    let patientAge = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      patientAge--;
    }
    setAge(patientAge);
  };

  const loadPatientBySampleId = (sampleId) => {
    setDisabled(1);
    setIconDisabled(0);
    setMessage("");
    axios
      .post(API_URL + "patient/patient-report-by-sample-id", {
        sample_id: sampleId,
      })
      .then((response) => {
        if (!response.data.status) {
          setDisabled(0);
          setIconDisabled(1);
          return null;
        }

        if (!response.data.data) {
          setDisabled(0);
          setIconDisabled(1);
          setMessage(
            "Either Wrong Sample ID Or Report Not Created. You Can Create by Following Link"
          );
          setPatient({ patient_tests: [] });
          return null;
        }

        let patientData = response.data.data;
        const needsTestDetails = patientData.patient_tests?.some(
          (pt) => !(pt.test?.details?.length > 0)
        );

        if (!needsTestDetails) {
          applyPatientData(patientData);
          setDisabled(0);
          setIconDisabled(1);
          return null;
        }

        axios
          .post(API_URL + "patient/patient-by-sample-id-report-update", {
            sample_id: sampleId,
          })
          .then((detailsResponse) => {
            if (detailsResponse.data.status && detailsResponse.data.data) {
              patientData = mergeTestDetailsFromSource(
                patientData,
                detailsResponse.data.data
              );
            }
            applyPatientData(patientData);
          })
          .catch(() => {
            applyPatientData(patientData);
          })
          .finally(() => {
            setDisabled(0);
            setIconDisabled(1);
          });
      })
      .catch((error) => {
        setDisabled(0);
        setIconDisabled(1);
        alertify.error("Error loading patient data");
      });
  };

  const resultHandler = (
    patient_test_index,
    patient_test_detail_index,
    value
  ) => {
    patient.patient_tests[patient_test_index].patient_test_details[
      patient_test_detail_index
    ].result = value;
    setPatient({ ...patient });

    const detailRow =
      patient.patient_tests[patient_test_index].patient_test_details[
        patient_test_detail_index
      ];
    const normalValues =
      detailRow.test_detail?.normal_values ||
      detailRow.test_detail?.normal_values_with_trashed ||
      [];

    normalValues.map((normalvalue, ind) => {
      if (
        (age <= normalvalue.to_age &&
          age >= normalvalue.from_age &&
          normalvalue.gender == patient.gender) ||
        (patient.patient_tests[patient_test_index].patient_test_details[
          patient_test_detail_index
        ].flag == undefined &&
          normalvalue.gender == "default")
      ) {
        if (value < parseFloat(normalvalue.minimum_value)) {
          $(
            "#row" + patient_test_index + "_" + patient_test_detail_index
          ).removeClass("normal-row");
          patient.patient_tests[patient_test_index].patient_test_details[
            patient_test_detail_index
          ].flag = "lower";
          $(
            "#row" + patient_test_index + "_" + patient_test_detail_index
          ).addClass("danger-row");
        } else if (value > parseFloat(normalvalue.maximum_value)) {
          patient.patient_tests[patient_test_index].patient_test_details[
            patient_test_detail_index
          ].flag = "high";
          $(
            "#row" + patient_test_index + "_" + patient_test_detail_index
          ).removeClass("normal-row");
          $(
            "#row" + patient_test_index + "_" + patient_test_detail_index
          ).addClass("danger-row");
        } else if (value.toLowerCase() == "negative") {
          patient.patient_tests[patient_test_index].patient_test_details[
            patient_test_detail_index
          ].flag = "negative";
          $(
            "#row" + patient_test_index + "_" + patient_test_detail_index
          ).removeClass("normal-row");
          $(
            "#row" + patient_test_index + "_" + patient_test_detail_index
          ).addClass("danger-row");
        } else {
          patient.patient_tests[patient_test_index].patient_test_details[
            patient_test_detail_index
          ].flag = "normal";
          $(
            "#row" + patient_test_index + "_" + patient_test_detail_index
          ).removeClass("danger-row");
          $(
            "#row" + patient_test_index + "_" + patient_test_detail_index
          ).addClass("normal-row");
        }
        setPatient({ ...patient });
      }
    });
  };

  const reportGetDataHandler = (e) => {
    e.preventDefault();
    const sampleId = sampleIdInput.current.value?.trim();
    if (sampleId) {
      history.replace(reportEditUrl(sampleId));
    }
    loadPatientBySampleId(sampleId);
  };

  const createReportHandler = (e) => {
    e.preventDefault();
    setDisabled(1);
    setIconDisabled(0);
    axios
      .post(API_URL + "patient/update-report", buildUpdateReportPayload(patient))
      .then((response) => {
        setDisabled(0);
        setIconDisabled(1);
        if (response.data.status) {
          alertify.success(response.data.data);
        } else {
          alertify.error(response.data.message || "Failed to save report");
        }
      })
      .catch((error) => {
        setDisabled(0);
        setIconDisabled(1);
        const msg =
          error.response?.data?.message ||
          error.message ||
          "Failed to save report";
        alertify.error(msg);
        if (error.message === "Request failed with status code 401") {
          //props.logout();
        }
      });
  };
  // const handleRemarksOnChange = (index, value) => {
  //   const cloned = patient;
  //   cloned.patient_tests[index].report_remarks_id = value;
  //   setPatient(cloned);
  //   console.log(cloned);
  // };
  const handleRemarksOnChange = (index, value) => {
    const updatedPatient = { ...patient };
    updatedPatient.patient_tests = [...patient.patient_tests];
    updatedPatient.patient_tests[index] = {
      ...patient.patient_tests[index],
      report_remarks_id: value,
    };
    setPatient(updatedPatient);
  };

  useEffect(() => {
    axios
      .get(API_URL + "report-remarks")
      .then((response) => {
        if (response.data.status) {
          setRemarks(response.data.data);
        }
      })
      .catch((error) => {
        alertify.error("Something went wrong. Try again!");
      });

    normalizeReportEditSearchUrl(history, location.search);
    const sampleIdFromUrl = sampleIdFromSearch(location.search);
    if (sampleIdFromUrl) {
      loadPatientBySampleId(sampleIdFromUrl);
    }
  }, [location.search]);

  return (
    <>
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader title="Edit Report">
              <CardHeaderToolbar>
                <Link
                  to="/patient/create"
                  className="btn btn-primary btn-sm mx-3"
                >
                  Create Patient
                </Link>
              </CardHeaderToolbar>
            </CardHeader>
            <div className={"mt-5"}>
              <Form onSubmit={reportGetDataHandler}>
                <Row className={"ml-5  mr-5 mb-10 "}>
                  <Col xs={12} md={4}>
                    <Form.Label>Sample ID</Form.Label>
                    <Form.Control
                      ref={sampleIdInput}
                      placeholder="Search By Sample ID"
                      defaultValue={sampleIdFromSearch(location.search)}
                    />
                  </Col>
                  <Col xs={12} md={2} style={{ marginTop: "20px" }}>
                    <Button
                      variant="primary"
                      size="lg"
                      className="float-right btn-block"
                      type="submit"
                      disabled={disabled}
                    >
                      Filter
                      <span
                        dangerouslySetInnerHTML={{
                          __html: disabled
                            ? `<i class='fas fa-spinner fa-spin'></i>`
                            : ``,
                        }}
                      />
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
            <CardBody>
              {Object.keys(patient).length > 1 ? (
                <>
                  <Table striped bordered hover>
                    <tbody>
                      <tr>
                        <th>Sample ID</th>
                        <th>{patient.sample_id}</th>
                        <th>Name</th>
                        <th>{patient.first_name + " " + patient.last_name}</th>
                      </tr>
                      <tr>
                        <th>Gender</th>
                        <th>{patient.gender}</th>
                        <th>DOB</th>
                        <th>{date_format(patient.dob)}</th>
                      </tr>
                      <tr>
                        <th>Phone No</th>
                        <th>{patient.phone_no}</th>
                        <th>Registeredat</th>
                        <th>{datetime_format(patient.registered_at)}</th>
                      </tr>
                    </tbody>
                  </Table>
                  <Row>
                    <Col md={12} className={"text-center mt-5 mb-5"}>
                      <h1>Generate Report</h1>
                    </Col>
                  </Row>

                  {patient.patient_tests.map((test, index) => (
                    <Row className="text-center" key={index}>
                      <Col md={12} className={"test-name"}>
                        <h3>{test.test.name}</h3>
                      </Col>
                      <Col md={12}>
                        <Table striped bordered hover>
                          <thead>
                            <tr variant="dark">
                              <th>Title</th>
                              <th>Unit</th>
                              <th>Result</th>
                            </tr>
                          </thead>
                          <tbody>
                            {test.patient_test_details.map(
                              (detail, element) => (
                                <tr
                                  className={
                                    isAbnormalResult(detail)
                                      ? "danger-row"
                                      : "normal-row"
                                  }
                                  key={
                                    getTestDetailId(detail) ?? element
                                  }
                                  id={"row" + index + "_" + element}
                                >
                                  <td>{detail.name}</td>
                                  <td>
                                    {detail.test_detail?.unit?.name ??
                                      detail.unit_id}
                                  </td>
                                  <td>
                                    {test.test.results_entry_mode ==
                                    "input" ? (
                                      <Form.Control
                                        placeholder="Enter Results"
                                        defaultValue={formatResultForDisplay(
                                          detail.result
                                        )}
                                        onKeyDown={(e) =>
                                          resultHandler(
                                            index,
                                            element,
                                            e.target.value
                                          )
                                        }
                                        onKeyUp={(e) =>
                                          resultHandler(
                                            index,
                                            element,
                                            e.target.value
                                          )
                                        }
                                        onKeyPress={(e) =>
                                          resultHandler(
                                            index,
                                            element,
                                            e.target.value
                                          )
                                        }
                                      />
                                    ) : (
                                      <Form.Control
                                        placeholder="Enter Results"
                                        defaultValue={
                                          formatResultForDisplay(
                                            detail.result
                                          ) || "Negative"
                                        }
                                        as="select"
                                        onChange={(e) =>
                                          resultHandler(
                                            index,
                                            element,
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option
                                          value={
                                            "Inclusive - please repeat"
                                          }
                                        >
                                          Inclusive - please repeat
                                        </option>
                                        <option value={"Positive"}>
                                          Positive
                                        </option>
                                        <option value={"Negative"}>
                                          Negative
                                        </option>
                                      </Form.Control>
                                    )}
                                  </td>
                                </tr>
                              )
                            )}
                            {/* remarks row */}
                            <tr style={{ background: "#ace178" }}>
                              <td className="">Choose Remarks (Optional)</td>
                              <td colSpan={2}>
                                <Form.Control
                                  as="select"
                                  onChange={(e) =>
                                    handleRemarksOnChange(index, e.target.value)
                                  }
                                  value={test.report_remarks_id || "0"}
                                >
                                  <option value={"0"}>Choose a remarks</option>
                                  {remarks.map((remark, index) => (
                                    <option key={index} value={remark.id}>
                                      {remark.name}
                                    </option>
                                  ))}
                                </Form.Control>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  ))}
                  <div className={"mt-5"}>
                    <Form onSubmit={createReportHandler}>
                      <Row className={"ml-5  mr-5 mb-10 "}>
                        <Col xs={12} md={12} style={{ marginTop: "15px" }}>
                          <Button
                            variant="primary"
                            size="lg"
                            className="float-right btn-block"
                            type="submit"
                            disabled={disabled}
                          >
                            Save
                            <span
                              dangerouslySetInnerHTML={{
                                __html: disabled
                                  ? `<i class='fas fa-spinner fa-spin'></i>`
                                  : ``,
                              }}
                            />
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </>
              ) : (
                <h3>{message}</h3>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
}
